export const STEP_COMPLETED = 'STEP_COMPLETED'
export const STEP_SAVED = 'STEP_SAVED'
export const STEP_FORWARD_NAVIGATED = 'STEP_FORWARD_NAVIGATED'

export const APPLICATION_INIT_REQUESTED = 'APPLICATION_INIT_REQUESTED'
export const APPLICATION_INIT_RECEIVED = 'APPLICATION_INIT_RECEIVED'

export const SAVE_PROGRESS_REQUESTED = 'SAVE_PROGRESS_REQUESTED'
export const SAVE_PROGRESS_RECEIVED = 'SAVE_PROGRESS_RECEIVED'

export const VALIDATE_ZIP_CODE_REQUESTED = 'VALIDATE_ZIP_CODE_REQUESTED'
export const VALIDATE_ZIP_CODE_RECEIVED = 'VALIDATE_ZIP_CODE_RECEIVED'
export const ZIP_CODE_NOT_FOUND = 'ZIP_CODE_NOT_FOUND'
export const UPDATE_COUNTY = 'UPDATE_COUNTY'
export const UPDATE_ZIP_CODE = 'UPDATE_ZIP_CODE'
export const SUBSCRIBE_TO_STATE_WAITING_LIST_REQUESTED =
  'SUBSCRIBE_TO_STATE_WAITING_LIST_REQUESTED'
export const SUBSCRIBE_TO_WAITING_LIST_RECEIVED =
  'SUBSCRIBE_TO_WAITING_LIST_RECEIVED'

export const APPLICATION_DATA_REQUESTED = 'APPLICATION_DATA_REQUESTED'
export const APPLICATION_DATA_RECEIVED = 'APPLICATION_DATA_RECEIVED'

export const SUBSCRIBE_TO_ENROLLMENT_REASON_WAITING_LIST_REQUESTED =
  'SUBSCRIBE_TO_ENROLLMENT_REASON_WAITING_LIST_REQUESTED'

export const QUALIFY_LIFE_EVENT_LOADED = 'QUALIFY_LIFE_EVENT_LOADED'
export const APPLICATION_ID_REMOVED = 'APPLICATION_ID_REMOVED'

export const QUALIFICATION_REASONS_REQUESTED = 'QUALIFICATION_REASONS_REQUESTED'
export const QUALIFICATION_REASONS_RECEIVED = 'QUALIFICATION_REASONS_RECEIVED'

export const SHARE_APPLICATION_REQUESTED = 'SHARE_APPLICATION_REQUESTED'
export const SHARE_APPLICATION_RECEIVED = 'SHARE_APPLICATION_RECEIVED'
